import React, { useState } from 'react';

import firebase from '../firebase';

import { BROADCAST_STATUS, MAX_BROADCAST_NOTE_LENGTH, NOTIFY_NOTE_CONTENT } from '../utils/constants';

const STAGES = {
    confirm: 'confirm',
    submit: 'submit',
};

function BroadcastNotifyModal({ setModalOpen, selectedBroadcast, getBroadcastDetails }) {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [note, setNote] = useState('');
    const [stage, setStage] = useState(STAGES.submit);

    function handleSubmit(e) {
        e.preventDefault();
        setIsSubmitting(true);

        const broadcastId = selectedBroadcast.id;
        firebase.addBroadcastNote(broadcastId, { noteContent: note.trim() || NOTIFY_NOTE_CONTENT, status: BROADCAST_STATUS.submitted })
            .then(() => getBroadcastDetails(broadcastId))
            .catch(err => alert(`Something went wrong. ${err.message || ''}`))
            .finally(() => {
                setIsSubmitting(false);
                setStage(STAGES.confirm);
            });
    }


    function onCancelClick(e) {
        e.preventDefault();
        if (!isSubmitting) setModalOpen(null);
    }

    function handleChange(e) {
        setNote(e.target.value);
    }

    if (stage === STAGES.confirm) return(
        <div>
            <div className="full-page-overlay" onClick={onCancelClick} />
            <div className="modal-container">
                <div className="modal-container__modal edit-modal">
                    <div className="edit-modal__title">
                        <h4 className="mdl-typography--title edit-modal__title">
                            Thank you!
                        </h4>
                        <p>
                            The team has been notified.
                        </p>
                        <p>
                            Your broadcast will be reviewed, and someone will confirm via email.
                        </p>
                        <p>
                            To make changes, simply update the form and resubmit.
                        </p>
                    </div>
                    <form onSubmit={onCancelClick}>
                        <div className="edit-modal__buttons">
                            <button
                                className="mdl-button mdl-button--raised button-responsive"
                                name="close"
                                type="submit"
                                disabled={isSubmitting}>
                                Close
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );


    return (
        <div>
            <div className="full-page-overlay" onClick={onCancelClick} />
            <div className="modal-container">
                <div className="modal-container__modal edit-modal">
                    <form onSubmit={handleSubmit}>
                        <div className="mdl-textfield" style={{ width: '100%' }}>
                            <textarea
                                id="note"
                                rows="5" cols="33"
                                maxLength={MAX_BROADCAST_NOTE_LENGTH}
                                placeholder="Add note here"
                                className="mdl-textfield__input edit-modal__input"
                                type="text"
                                name="note"
                                value={note}
                                onChange={handleChange} />
                        </div>
                        {note.length >= MAX_BROADCAST_NOTE_LENGTH && (
                            <div>
                                Max character limit reached ({MAX_BROADCAST_NOTE_LENGTH})
                            </div>
                        )}
                        <div className="edit-modal__buttons">
                            <button
                                className="mdl-button mdl-button--raised button-responsive"
                                name="cancel"
                                type="button"
                                onClick={onCancelClick}
                                disabled={isSubmitting}>
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="mdl-button mdl-button--raised button-blue button-responsive"
                                name="save"
                                disabled={isSubmitting}>
                                Submit for Review
                                {isSubmitting &&
                                    <i className="material-icons rotating" role="presentation">
                                        rotate_right
                                    </i>
                                }
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default BroadcastNotifyModal;
